import request from './base'
export const getCarList = (params) => {
    return request.post("/merchant/v1/car/list", params)
}
export const getCarSelect = () => {
    return request.post("/merchant/v1/car/select")
}
export const modifyCar = (params) => {
    return request.post("/merchant/v1/car/modify", params)
}
export const getCarLogs = (params) => {
    return request.post("/merchant/v1/car/logs", params)
}

export const getCarPosition = (params) => {
    return request.post("/merchant/v1/car/position", params)
}

export const getCompanyCarList = (params) => {
    return request.post("/merchant/v1/car/companyCarList", params)
}


// WEBPACK FOOTER //
// ./src/api/car.js